// extracted by css-extract-rspack-plugin
export default {"dateTime":"src-modules-auth-templates-AuthPageTemplate-DateTime-DateTime-module__dateTime-ygJ7Oh","time":"src-modules-auth-templates-AuthPageTemplate-DateTime-DateTime-module__time-b8OFg4","date":"src-modules-auth-templates-AuthPageTemplate-DateTime-DateTime-module__date-lou90S"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"dateTime\":\"src-modules-auth-templates-AuthPageTemplate-DateTime-DateTime-module__dateTime-ygJ7Oh\",\"time\":\"src-modules-auth-templates-AuthPageTemplate-DateTime-DateTime-module__time-b8OFg4\",\"date\":\"src-modules-auth-templates-AuthPageTemplate-DateTime-DateTime-module__date-lou90S\"}";
        // 1793872698314
        var cssReload = require("../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  